namespace $ {

	export class $shm_ba_filter_state_store extends $mol_object2 {

		app_id() {
			return ''
		}

		has_source() {
			return false
		}

		period_all(): $shm_ba_data_period {
			return {
				from: '0001-01-01',
				to: '2999-12-31',
			}
		}

		default(): $shm_ba_filter_state {
			return {
				tags_filter: {},
				authors_filter: {},
				sources_filter: {},
				search_query: '',
				search_query_draft: '',
				search_mode: 'fts',
				search_case_sensitive: true,
				chart_metric: 'Сообщений',
				chart_group: 'day',
				posts_sort: 'Дата',
				posts_sort_order: 'desc',
				message_types_filter: {},
				source_types_filter: {},
			}
		}

		key( id: string ) {
			return `hitalama_ba_filter:${ this.app_id() }:${ id }`
		}

		last_id_key() {
			return `hitalama_ba_filter_last:${ this.app_id() }`
		}

		last_id( next?: string | null ) {
			return $mol_state_local.value< string >( this.last_id_key(), next ) ?? ''
		}

		state( id: string, next?: $shm_ba_filter_state | null ) {
			return $mol_state_local.value< $shm_ba_filter_state >( this.key( id ), next )
		}

		id() {
			return $mol_state_arg.value( 'ba_filter_id' )
		}

		current() {
			const id = this.id()
			const state = id ? this.state( id ) : null
			return state ?? this.default()
		}

		filter_signature( filter: $shm_ba_data_filter | undefined ) {
			return Object.keys( filter ?? {} )
				.sort()
				.map( key => [ key, filter![ key ] ] )
		}

		filter_from_signature( signature: readonly ( readonly [ string, $shm_ba_data_filter_value ] )[] ) {
			const filter = {} as $shm_ba_data_filter
			for( const [ key, value ] of signature ) filter[ key ] = value
			return filter
		}

		@ $mol_mem
		data_current_signature() {
			const state = this.current()

			return JSON.stringify({
				file_uri: state.file_uri ?? '',
				local_file_key: state.local_file_key ?? '',
				period: state.period ?? null,
				tags_filter: this.filter_signature( state.tags_filter ),
				authors_filter: this.filter_signature( state.authors_filter ),
				sources_filter: this.filter_signature( state.sources_filter ),
				message_types_filter: this.filter_signature( state.message_types_filter ),
				source_types_filter: this.filter_signature( state.source_types_filter ),
				search_query: state.search_query ?? '',
				search_mode: state.search_mode ?? 'fts',
				search_case_sensitive: state.search_case_sensitive ?? true,
				posts_sort: state.posts_sort ?? 'Дата',
				posts_sort_order: state.posts_sort_order ?? 'desc',
			})
		}

		@ $mol_mem
		data_current() {
			const state = JSON.parse( this.data_current_signature() ) as {
				file_uri: string
				local_file_key: string
				period: $shm_ba_data_period | null
				tags_filter: [ string, $shm_ba_data_filter_value ][]
				authors_filter: [ string, $shm_ba_data_filter_value ][]
				sources_filter: [ string, $shm_ba_data_filter_value ][]
				message_types_filter: [ string, $shm_ba_data_filter_value ][]
				source_types_filter: [ string, $shm_ba_data_filter_value ][]
				search_query: string
				search_mode: $shm_ba_data_search_mode
				search_case_sensitive: boolean
				posts_sort: string
				posts_sort_order: 'asc' | 'desc'
			}

			return {
				file_uri: state.file_uri,
				local_file_key: state.local_file_key,
				period: state.period ?? undefined,
				tags_filter: this.filter_from_signature( state.tags_filter ),
				authors_filter: this.filter_from_signature( state.authors_filter ),
				sources_filter: this.filter_from_signature( state.sources_filter ),
				message_types_filter: this.filter_from_signature( state.message_types_filter ),
				source_types_filter: this.filter_from_signature( state.source_types_filter ),
				search_query: state.search_query,
				search_mode: state.search_mode,
				search_case_sensitive: state.search_case_sensitive,
				posts_sort: state.posts_sort,
				posts_sort_order: state.posts_sort_order,
			}
		}

		save( next: Partial< $shm_ba_filter_state > ) {
			const id = $mol_guid()
			const state = {
				... this.current(),
				... next,
			}
			this.state( id, state )
			this.last_id( id )
			$mol_state_arg.value( 'ba_filter_id', id )
			$mol_state_arg.commit()
			return state
		}

		file_uri( next?: string ) {
			if( next === undefined ) return this.data_current().file_uri
			this.save({ file_uri: next })
			return next
		}

		local_file_key( next?: string ) {
			if( next === undefined ) return this.data_current().local_file_key
			this.save({ local_file_key: next })
			return next
		}

		date_fit( date: string ) {
			const time = date.match( /^\d{4}-\d{2}-\d{2}[ T](\d{2}):(\d{2})/ )
			const match = date.slice( 0, 10 ).match( /^(\d{4})-(\d{2})-(\d{2})$/ )
			if( !match ) return date

			const year = Number( match[1] )
			const month = Math.min( 12, Math.max( 1, Number( match[2] ) ) )
			const day_max = new Date( year, month, 0 ).getDate()
			const day = Math.min( day_max, Math.max( 1, Number( match[3] ) ) )

			const result = [
				String( year ).padStart( 4, '0' ),
				String( month ).padStart( 2, '0' ),
				String( day ).padStart( 2, '0' ),
			].join( '-' )
			return time ? `${ result } ${ time[1] }:${ time[2] }` : result
		}

		period_fit( period: $shm_ba_data_period ) {
			let from = this.date_fit( period.from )
			let to = this.date_fit( period.to )
			if( from && to && from > to ) {
				if( period.from !== from ) to = from
				else from = to
			}
			return { from, to }
		}

		period( next?: $shm_ba_data_period ) {
			if( next === undefined ) return this.period_fit( this.data_current().period ?? ( this.has_source() ? this.period_all() : {
				from: '0001-01-01',
				to: '2999-12-31',
			} ) )
			next = this.period_fit( next )
			this.save({ period: next })
			return next
		}

		tags_filter( next?: $shm_ba_data_filter ) {
			if( next === undefined ) return this.data_current().tags_filter
			this.save({ tags_filter: next })
			return next
		}

		message_types_filter( next?: $shm_ba_data_filter ) {
			if( next === undefined ) return this.data_current().message_types_filter
			this.save({ message_types_filter: next })
			return next
		}

		source_types_filter( next?: $shm_ba_data_filter ) {
			if( next === undefined ) return this.data_current().source_types_filter
			this.save({ source_types_filter: next })
			return next
		}

		authors_filter( next?: $shm_ba_data_filter ) {
			if( next === undefined ) return this.data_current().authors_filter
			this.save({ authors_filter: next })
			return next
		}

		sources_filter( next?: $shm_ba_data_filter ) {
			if( next === undefined ) return this.data_current().sources_filter
			this.save({ sources_filter: next })
			return next
		}

		search_query( next?: string ) {
			if( next === undefined ) return this.data_current().search_query
			this.save({ search_query: next })
			return next
		}

		search_mode( next?: string ) {
			const valid = new Set< string >([ 'fts', 'substring' ])
			if( next === undefined ) {
				const mode = this.data_current().search_mode
				return valid.has( mode ) ? mode : 'fts'
			}
			const mode = valid.has( next ) ? next : 'fts'
			this.save({ search_mode: mode as $shm_ba_data_search_mode })
			return mode
		}

		search_case_sensitive( next?: boolean ) {
			if( next === undefined ) return this.data_current().search_case_sensitive
			this.save({ search_case_sensitive: next })
			return next
		}

		chart_metric( next?: string ) {
			if( next === undefined ) return this.current().chart_metric ?? 'Сообщений'
			this.save({ chart_metric: next })
			return next
		}

		chart_group( next?: string ) {
			if( next === undefined ) return this.current().chart_group ?? 'day'
			this.save({ chart_group: next as $shm_ba_chart_group })
			return next
		}

		posts_sort( next?: string ) {
			if( next === undefined ) return this.data_current().posts_sort
			this.save({ posts_sort: next })
			return next
		}

		posts_sort_order( next?: string ) {
			if( next === undefined ) return this.data_current().posts_sort_order
			this.save({ posts_sort_order: next as 'asc' | 'desc' })
			return next
		}

		reset() {
			return this.save({
				... this.default(),
				file_uri: this.file_uri(),
				local_file_key: this.local_file_key(),
				period: this.period_all(),
			} )
		}

	}

}
